import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null; // No error if the field is empty
    }

    const isWhitespace = (value as string).trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  };
}
